import * as InquiryConstant from '../constants/inquiry.constant'
import { Inquiry } from '../interfaces/inquiry'

export interface State {
  inquiries: Inquiry[]
  details: Inquiry
  isFetching: Boolean
  question: string
}

export const initialState: State = {
  inquiries: null,
  details: null,
  isFetching: false,
  question: '',
}

const inquiry = (state: any = initialState, action: any) => {
  switch (action.type) {
    case InquiryConstant.GET_INQUIRY_LOGS:
      return {
        ...state,
        isFetching: true,
        inquiries: action.payload,
      }
    case InquiryConstant.GET_INQUIRY_LOGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
      }
    case InquiryConstant.GET_INQUIRY_LOG_DETAILS:
      return {
        ...state,
        isFetching: true,
        details: action.payload,
      }
    case InquiryConstant.GET_INQUIRY_LOG_DETAILS_SUCCESS:
      return {
        ...state,
        isFetching: false,
      }
    case InquiryConstant.POST_INQUIRY_QUESTION:
      console.log('inquiry.reducer: post')
      return {
        ...state,
        isFetching: false,
        question: action.payload,
      }
    case InquiryConstant.DONE_POST_INQUIRY_QUESTION:
      console.log('inquiry.reducer: done')
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default inquiry



// WEBPACK FOOTER //
// ./src/reducers/inquiry.reducer.ts